import React, { useState } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Navbar = ({ onRegisterClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <div className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-orange-500 bg-clip-text text-transparent">
              IDROMO
            </div>
            <span className="ml-2 text-sm text-gray-600 hidden sm:inline">Italia</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('servizi')} className="text-gray-700 hover:text-blue-600 transition-colors">
              Servizi
            </button>
            <button onClick={() => scrollToSection('chi-siamo')} className="text-gray-700 hover:text-blue-600 transition-colors">
              Chi Siamo
            </button>
            <button onClick={() => scrollToSection('recensioni')} className="text-gray-700 hover:text-blue-600 transition-colors">
              Recensioni
            </button>
            <button onClick={() => scrollToSection('contatti')} className="text-gray-700 hover:text-blue-600 transition-colors">
              Contatti
            </button>
            <a href="tel:3514826210" className="flex items-center text-blue-600 hover:text-blue-700 transition-colors">
              <Phone className="w-4 h-4 mr-2" />
              <span className="font-semibold">351 482 6210</span>
            </a>
            <Button onClick={onRegisterClick} className="bg-orange-500 hover:bg-orange-600 text-white">
              Registrati
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-gray-700">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('servizi')} className="block w-full text-left py-2 text-gray-700">
              Servizi
            </button>
            <button onClick={() => scrollToSection('chi-siamo')} className="block w-full text-left py-2 text-gray-700">
              Chi Siamo
            </button>
            <button onClick={() => scrollToSection('recensioni')} className="block w-full text-left py-2 text-gray-700">
              Recensioni
            </button>
            <button onClick={() => scrollToSection('contatti')} className="block w-full text-left py-2 text-gray-700">
              Contatti
            </button>
            <a href="tel:3514826210" className="flex items-center py-2 text-blue-600">
              <Phone className="w-4 h-4 mr-2" />
              351 482 6210
            </a>
            <Button onClick={onRegisterClick} className="w-full bg-orange-500 hover:bg-orange-600 text-white">
              Registrati
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};
